module.exports = __webpack_public_path__ + "img/remind@3x.d611bd74.png";